import { jsx as _jsx } from "react/jsx-runtime";
import { BaseNumberChart } from './base_number_chart.component';
export const NumberChart = (props) => {
    return _jsx(BaseNumberChart, { ...props });
};
